/* eslint-disable no-undef */
export const ENDPOINTS = {
  BASE_URL: process.env.REACT_APP_SECURITY360_BASE_URL
};
